module.exports = __webpack_public_path__ + "img/wordThree.ae054307.png";